import { render, staticRenderFns } from "./FooterFixed.vue?vue&type=template&id=4e604352&scoped=true&"
import script from "./FooterFixed.vue?vue&type=script&lang=js&"
export * from "./FooterFixed.vue?vue&type=script&lang=js&"
import style0 from "./FooterFixed.vue?vue&type=style&index=0&id=4e604352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e604352",
  null
  
)

export default component.exports